import {
  MemberGroupTable,
  MemberGroup as MemberGroupType,
} from "@/types/member";
import { ApiResponse } from "@/types";

import { apiSlice } from "@/redux/apiSlice";

export const MemberGroup = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getMemberGroups: builder.query<MemberGroupTable, void>({
        query: () => ({
          url: `/member/group`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MemberGroup"],
      }),
      getMemberGroupById: builder.query<MemberGroupType, number>({
        query: (id) => ({
          url: `/member/group/${id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MemberGroup"],
      }),
      createMemberGroup: builder.mutation<ApiResponse, MemberGroupType>({
        query: (memberdata) => ({
          url: `/member/group`,
          method: "POST",
          body: memberdata,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["MemberGroup"],
      }),
      updateMemberGroup: builder.mutation<ApiResponse, MemberGroupType>({
        query: (memberdata) => ({
          url: `/member/group/${memberdata.id}`,
          method: "PUT",
          body: memberdata,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["MemberGroup"],
      }),
      deleteMemberGroup: builder.mutation<ApiResponse, number>({
        query: (id) => ({
          url: `/member/group/${id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["MemberGroup"],
      }),
    };
  },
});

export const {
  useGetMemberGroupsQuery,
  useGetMemberGroupByIdQuery,
  useCreateMemberGroupMutation,
  useUpdateMemberGroupMutation,
  useDeleteMemberGroupMutation,
} = MemberGroup;
